import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, marginBottom } from '../../../helpers/getEmailStyles';

class ContactSupport extends React.Component {

    static propTypes = {
        content: PropTypes.shape({
            ContactMessage: PropTypes.string.isRequired,
            email: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            userType: PropTypes.string.isRequired,
            listId: PropTypes.number.isRequired,
            confirmationCode: PropTypes.number.isRequired,
        })
    };

    render() {
        const { content: { ContactMessage, email, name, confirmationCode, userType, listId, logo, siteName } } = this.props;

        return (
            <Layout>
                <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
                <div style={body}>
                    <div style={fontWeightBold}>
                        Bonjour Admin,
                    </div>
                    <EmptySpace height={20} />
                    <div>
                        Un {userType} souhaite vous contacter pour le support, concernant la réservation #{confirmationCode} sur la propriété ID {listId}.
                    </div>
                    <EmptySpace height={20} />
                    <div style={marginBottom}><span style={fontWeightBold}>Nom du contact :</span> {name}</div>
                    <div style={marginBottom}><span style={fontWeightBold}>E-mail du contact :</span> {email}</div>
                    <div style={marginBottom}><span style={fontWeightBold}>Message :</span></div>
                    <div>
                        {
                            ContactMessage && (ContactMessage.trim()).split("\n").map(function (item, index) {
                                return (
                                    <span>{item}<br /></span>
                                )
                            })
                        }
                    </div>
                    <EmptySpace height={20} />
                    <EmailSignature siteName={siteName} />
                </div>
                <EmptySpace height={40} />
                <Footer siteName={siteName} />
                <EmptySpace height={20} />
            </Layout>
        );
    }

}

export default ContactSupport;